// mydatafeed/core/state.js
export const endOfHistory  = new Map();
export const inflight      = new Set();
export const subscribers   = {};   // { [uid]: intervalId }
export const lastSentBars  = {};   // { [uid]: lastBar }
export const overrideEvents = { data: null }; // si quieres setear eventos “fijos” en memoria
